import { addDays } from 'date-fns';

// Import types
import type { SummaryProduct } from 'types/views/configurator';

// Import helpers
import { convertDateToDayMonthYear } from 'helpers/time';

export const getNextBillingDate = (days: number, date?: string) => convertDateToDayMonthYear(addDays(date ?? new Date(), days));

export const getLongestPromotionDays = (products: SummaryProduct[]) =>
	products.reduce((maxDuration, product) => {
		const promo_days_period = product.promotion?.promo_days_period;
		if (!promo_days_period) return maxDuration;
		return promo_days_period > maxDuration ? promo_days_period : maxDuration;
	}, 0);
